module.exports = __webpack_public_path__ + "img/services-it-infra.d51f8834.png";